import type { EntityGraphNode } from "../engine/EntityGraphNode/EntityGraphNode.type"
import type { HasEntityTypeId } from "./EntityTypeId.enum"
import type { Entity } from "./index"
import { waterEntityTypeIdList } from "./waterEntityTypeIdList"
import type { WaterEntityUnion } from "./WaterEntityUnion.type"

/**
 * requirements
 * - A "water" entity is one that which a shoal entity will "dip" into.
 * 
 * @param entity 
 * @returns boolean
 */

function isEntityWater<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<WaterEntityUnion>

function isEntityWater(
  entity: Entity
): entity is WaterEntityUnion

function isEntityWater<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: WaterEntityUnion['etype_id']} {
  return waterEntityTypeIdList.includes(entity.etype_id)
}

export default isEntityWater
